import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { actions, ActionType } from "../constants/appActions";


type ApiState = {
  status?: number;
  code?: string;
  action?: (typeof actions)[keyof typeof actions];
  actionType?: (typeof ActionType)[keyof typeof ActionType];
  message?: string;
  detail?: string;
  showDetails?: string | string[];
  timestamp?: number;
};

const initialState: ApiState = {};

export const apiStateSlice = createSlice({
  name: "apiState",
  initialState,
  reducers: {
    setApiState: (state: ApiState, action: PayloadAction<ApiState>) => {
      state.status = action.payload.status;
      state.code = action.payload.code;
      state.action = action.payload.action;
      state.actionType = action.payload.actionType;
      state.message = action.payload.message;
      state.detail = action.payload.detail;
      state.showDetails = action.payload.showDetails;
      state.timestamp = Date.now();
    },
    clearApiState: (state: ApiState) => {
      state.status = undefined;
      state.action = undefined;
      state.actionType = undefined;
      state.message = undefined;
      state.code = undefined;
      state.detail = undefined;
      state.showDetails = undefined;
      state.timestamp = undefined;
    },
  },
});

export const { setApiState, clearApiState } = apiStateSlice.actions;
export default apiStateSlice.reducer;
